import React from 'react'

import { SVG_FILE_PREVIEW_TEST_ID } from './FileContent'
import { InnerWrapper, StyledContent, Wrapper } from './FileContents.styles'
import { NoContent } from './NoContent'

interface SVGViewerProps {
  data?: string
}

export const SVGViewer = ({ data }: SVGViewerProps) => {
  if (!data) return <NoContent />

  return (
    <Wrapper>
      <InnerWrapper>
        <StyledContent>
          <img
            src={`data:image/svg+xml;utf8,${encodeURIComponent(data)}`}
            width="100%"
            height="100%"
            alt="SVG"
            data-testid={SVG_FILE_PREVIEW_TEST_ID}
          />
        </StyledContent>
      </InnerWrapper>
    </Wrapper>
  )
}
